export default __webpack_public_path__ + "assets/icons/au.e95f7c63.svg";